import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { homeNode } from "motw_core/Repositories/WorkflowRepository";
import classNames from "classnames";
import * as React from "react";
import { SetRootNodeAsync } from "../../../../../services/Workflows/SetRootNode";
import { ChildNodeName } from "../../RenderChildNodes/ChildNodeName/ChildNodeName";
import * as styles from "./SearchResult.css";


export function SearchResult({
    node,
    isFavorite,
}: {
    node: IWorkflowNode;
    isFavorite: boolean;
}) {
    return (
        <div
            className={classNames(styles.result, {
                [styles.favoriteResult]: isFavorite,
            })}
        >
            <ChildNodeName
                rootNode={homeNode}
                level={1}
                setRootNodeId={(rootNodeId: number) => {
                    SetRootNodeAsync(rootNodeId);
                }}
                children={[]}
                node={node}
                randomNode={homeNode}
                visibleNodes={[]}
                quizMode={false}
                sortMode={false}
                sortSource={homeNode}
                scrambledNode={homeNode}
                index={0}
                limitNameDisplayLength
            />
        </div>
    );
}
